import React from 'react';
import { Alert, Badge, Button, Card, Form, Spinner } from '@themesberg/react-bootstrap';
import { states, safeImage, stamp } from './model';

export function ErrorNotice({ error }) {
  if (!error) return null;
  return <Alert variant="danger" role="alert"><strong>{error.message || String(error)}</strong>
    {Object.keys(error.fields || {}).length > 0 && <div className="small mt-1">Trường cần kiểm tra: {Object.keys(error.fields).join(', ')}</div>}
    {error.requestId && <div className="small mt-1">Mã yêu cầu: {error.requestId}</div>}
  </Alert>;
}
export function Feedback({ mutation }) {
  return <><ErrorNotice error={mutation.error} />{mutation.success && <Alert variant="success" role="status">{mutation.success}</Alert>}</>;
}
export function QueryState({ query, empty }) {
  return <>{query.loading && <div className="py-4 text-center" role="status"><Spinner size="sm" animation="border" /> Đang tải…</div>}
    <ErrorNotice error={query.error} />{!query.loading && !query.error && empty && <p className="text-muted py-4 text-center">Chưa có dữ liệu phù hợp.</p>}</>;
}
export function Pane({ title, children, actions }) {
  return <Card className="border-0 shadow-sm mb-3"><Card.Body>
    {title && <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3"><h5 className="mb-0">{title}</h5>{actions}</div>}{children}
  </Card.Body></Card>;
}
export function Field({ label, children, hint }) {
  return <Form.Group className="mb-3"><Form.Label>{label}</Form.Label>{children}{hint && <div className="small text-muted mt-1">{hint}</div>}</Form.Group>;
}
export function Status({ value }) {
  const color = ['completed', 'succeeded'].includes(value) ? 'success' : ['failed', 'cancelled'].includes(value) ? 'danger' : value === 'draft' ? 'secondary' : 'info';
  return <Badge bg={color}>{states[value] || value}</Badge>;
}
export function Pager({ cursor, next, onNext, onBack, onReset, disabled }) {
  return <div className="d-flex justify-content-end gap-2 mt-3">
    <Button size="sm" variant="outline-secondary" onClick={onReset} disabled={disabled || !cursor}>Trang đầu</Button>
    <Button size="sm" variant="outline-secondary" onClick={onBack} disabled={disabled || !cursor}>Trước</Button>
    <Button size="sm" variant="outline-primary" onClick={onNext} disabled={disabled || !next}>Tiếp</Button>
  </div>;
}
export function usePaging() {
  const [stack, setStack] = React.useState([undefined]);
  return { cursor: stack[stack.length - 1], next: cursor => setStack(value => [...value, cursor]),
    back: () => setStack(value => value.slice(0, -1)), reset: () => setStack([undefined]) };
}
export function MessagePreview({ payload, expiresAt, label = 'Xem trước hộp thông báo' }) {
  const image = safeImage(payload?.image?.url);
  return <div className="noti-phone"><div className="small text-muted mb-3">{label}</div>
    {image && <img className="noti-banner" src={image} alt={payload.image.alt || ''} onError={event => { event.currentTarget.style.display = 'none'; }} />}
    <h5>{payload?.title || 'Tiêu đề thông báo'}</h5><p className="noti-body">{payload?.body || 'Nội dung thông báo'}</p>
    {payload?.action?.kind !== 'none' && payload?.action?.label && <span className="noti-cta">{payload.action.label}</span>}
    {expiresAt && <div className="small text-muted mt-3">Hiệu lực đến {stamp(expiresAt)}</div>}
  </div>;
}
